import { memo, useEffect, useState } from "react";

import formatDuration from "@/utils/formaty";

import PropTypes from "prop-types";

function Timer(props) {
  const [timer, setTimer] = useState("0:00");

  useEffect(() => {
    const updateClock = (startTime) => {
      const startDateTime = new Date(startTime * 1000).getTime();
      const currentDateTime = new Date().getTime();
      let diff = Math.round((currentDateTime - startDateTime) / 1000);
      setTimer(formatDuration(diff));
    };

    const interval = setInterval(() => updateClock(props.startTime), 1000);

    return () => clearInterval(interval);
  }, [props.startTime]);

  return timer;
}

Timer.propTypes = {
  startTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default memo(Timer);
